import { render, staticRenderFns } from "./HyperQ.vue?vue&type=template&id=a98c5fa0&scoped=true&"
import script from "./HyperQ.vue?vue&type=script&lang=js&"
export * from "./HyperQ.vue?vue&type=script&lang=js&"
import style0 from "./HyperQ.vue?vue&type=style&index=0&id=a98c5fa0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98c5fa0",
  null
  
)

export default component.exports